import { cn } from '../../lib/utils';

/**
 * A shot's number in its filled box: the editor, the shot list, the frame
 * lightbox and the shared page all show it this way, so it reads as one mark.
 */
export default function ShotNumber({ number, className }) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center shrink-0 tabular-nums text-xs font-medium px-1.5 py-0.5 rounded-small bg-inverse text-inverse-foreground',
        className,
      )}
    >
      {number}
    </span>
  );
}
